var alignmentStyle = {"alignLeft":"ITKFz","textWrapNowrap":"ZjttI","alignRight":"_5lzrZ","alignCenter":"dGMv-","sizeFullWidth":"_-4PGM","renderedInTable":"LuhCB","sizeOriginal":"zi-iY","sizeContent":"_6-Ldg","sizeSmall":"eMigG","sizeSmallCenter":"_36us8","flex":"XcKu-","LEFT":"KFmam","CENTER":"_3mFGb","RIGHT":"_4wOAM","AUTO":"_8nare","JUSTIFY":"eT4oq"};

export { alignmentStyle as a };
//# sourceMappingURL=alignment.rtlignore-2c0e3bc2.js.map
